export default "__VITE_PUBLIC_ASSET__5d942747__"